@if ($props(); as props) {
    @switch (props.state) {
        @case ("publish") {
            <button [matTooltip]="props.tooltip" class="cm-button cm-unavailable" disableAfterClick (click)="props.onTrigger()">
                @if (props.icon) {
                    <i [class]="props.icon"></i>
                }
                <span class="label">{{ props.label }}</span>
                <i class="fa-regular fa-play"></i>
            </button>
        }
        @case ("republish") {
            <button [matTooltip]="props.tooltip" class="cm-button" disableAfterClick (click)="props.onTrigger()">
                <div class="cm-inline-buttons">
                    <div class="cm-main-action">
                        @if (props.icon) {
                            <i [class]="props.icon"></i>
                        }
                        <span class="label">{{ props.label }}</span>
                        <i class="fa-regular fa-play"></i>
                    </div>
                    <!-- Same marker the outputs button uses for "source updates available". -->
                    <div class="cm-inline-actions">
                        <i class="fa-regular fa-circle-exclamation info"></i>
                    </div>
                </div>
            </button>
        }
        @case ("retry") {
            <button [matTooltip]="props.tooltip" class="cm-button" disableAfterClick (click)="props.onTrigger()">
                @if (props.icon) {
                    <i [class]="props.icon"></i>
                }
                <span class="label">{{ props.label }}</span>
                <i class="fa-regular fa-exclamation-triangle"></i>
                <i class="fa-regular fa-rotate"></i>
            </button>
        }
        @case ("inFlight") {
            <button [matTooltip]="props.tooltip" class="cm-button" disabled>
                @if (props.icon) {
                    <i [class]="props.icon"></i>
                }
                <span class="label">{{ props.label }}</span>
                <cm-loading-spinner-icon></cm-loading-spinner-icon>
            </button>
        }
        @case ("upToDate") {
            <button [matTooltip]="props.tooltip" class="cm-button cm-current" disabled>
                @if (props.icon) {
                    <i [class]="props.icon"></i>
                }
                <span class="label">{{ props.label }}</span>
                <i class="fa-regular fa-check"></i>
            </button>
        }
        @case ("blocked") {
            <button [matTooltip]="props.tooltip" class="cm-button cm-create-disabled" disabled>
                @if (props.icon) {
                    <i [class]="props.icon"></i>
                }
                <span class="label">{{ props.label }}</span>
                <i class="fa-regular fa-ban"></i>
            </button>
        }
    }
}
